export default {
  templateEdit: {},
  listTemplate: []
}
